import React from "react";

function MarkQuestion({ content }) {
  return (
    <div
      style={{
        maxWidth: "100%",
        overflow: "auto",
      }}>
      <pre
        style={{
          fontFamily: "Roboto Mono",
          userSelect: "none",
          fontSize: "12px",
        }}>
        {content}
      </pre>
    </div>
  );
}

export default MarkQuestion;
